import React, { FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import FormError from '@components/FormError'
import RadioGroup from '@components/RadioGroup/RadioGroup'
import Input from '@components/Input'
import RadioButton from '@components/RadioButton'
import PatientNameWrapper from '../PatientNameWrapper'
import useStyles from './PatientDetails.styles'
import Birthdate from '../Birthdate/Birthdate'
import { ReactComponent as DefaultPractitionerImage } from 'src/images/practitioner-default.svg'
import { differenceInYears, parse } from 'date-fns'

const MIN_ADULT_AGE_IN_YEARS = 18

const PatientDetails = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const {
    register,
    resetField,
    formState: { errors },
  } = useFormContext()

  return (
    <div className={classes.root}>
      <RadioGroup>
        <RadioButton id="patient_female" label={t('mrs')} {...register('patient_gender')} />
        <RadioButton id="patient_male" label={t('mr')} {...register('patient_gender')} />
        <RadioButton id="patient_diverse" label={t('divers')} {...register('patient_gender')} />
      </RadioGroup>

      <PatientNameWrapper>
        <Input
          required
          icon={<DefaultPractitionerImage />}
          type="text"
          placeholder={t('patient_first_name')}
          {...register('patient_firstName')}
          info={errors.patient_firstName && <FormError message={errors.patient_firstName.message} />}
        />
        <Input
          required
          icon={<DefaultPractitionerImage />}
          type="text"
          placeholder={t('patient_last_name')}
          {...register('patient_lastName')}
          info={errors.patient_lastName && <FormError message={errors.patient_lastName.message} />}
        />
      </PatientNameWrapper>

      <Birthdate
        id="patient_birthdate"
        onChange={(e: FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          const { value } = e.target as HTMLInputElement
          const parsedDate = parse(value, 'dd.MM.yyyy', new Date())
          const age = differenceInYears(new Date(), parsedDate)

          if (age < MIN_ADULT_AGE_IN_YEARS) {
            resetField('insurance_holder')
          }
        }}
      />
    </div>
  )
}

export default PatientDetails
